<template>
  <AddTeacher />
</template>
<script>
import appConfig from '@/app.config'
import AddTeacher from '../../../components/mooc/teachers/AddTeacher.vue'
export default {
  page: {
    title: 'اضافه کردن استاد',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'mooc-add-teachers',
  components: {
    AddTeacher,
  },
}
</script>
